module.exports = __webpack_public_path__ + "static/media/notes.71b5b951.gif";